import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
        zIndex: 9999
    },
})

class Loader extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <CircularProgress size={60} className={classes.buttonProgress} />
        )
    }

}

export default withStyles(styles)(Loader);



// WEBPACK FOOTER //
// ./src/Components/Loader.js